import { RootState } from '../Store';

export const selectAchievementsByUsername = (username: string) => (state: RootState) =>
  state.achievement.byUsername[username] ?? [];

export const selectAchievementsLoading = (username: string) => (state: RootState) =>
  state.achievement.loadingFor === username;

export const selectFullAchievements = (username: string) => (state: RootState) =>
  state.achievement.fullByUsername[username];

export const selectFullAchievementsLoading = (username: string) => (state: RootState) =>
  state.achievement.loadingFullFor === username;

export const selectSavingFeatured = (state: RootState) =>
  state.achievement.savingFeatured;

export const selectEarnConfig = (state: RootState) => state.achievement.earnConfig;

export const selectEarnConfigLoading = (state: RootState) =>
  state.achievement.earnConfigLoading;
